(function() {
  // Edit translations below
  var TRANSLATIONS = {
    SELECT_SHAPE: "SELECT SHAPE",
    SELECT_BLADE: "SELECT BLADE",
    SELECT_HANDLE: "SELECT HANDLE",
    YOUR_SELECTION: "YOUR SELECTION",
    CONFIRM_SELECTION: "Confirm selection",
    REMOVE_SELECTION: "Remove selection",
    HANDLING_TITLE: "Handle & blade fitting",
    HANDLING_DESCRIPTION: "Add this service if you want us to assemble the blade and the handle.",
    PREVIEW_TITLE: "KNIFE CONFIGURATOR - Build your own knife",
    BROWSER_NOT_SUPPORTED: "Your browser is not supported. To access Knife Configurator, use Chrome, Edge, Firefox or Safari.",
    NO_SHAPES: "There are no shapes available.",
    NO_BLADES: "No blades available for selected shape and/or handle size. Try selecting a different handle.",
    NO_HANDLES: "No handles available for selected shape and/or blade size. Try selecting a different blade.",
    RESET_CONFIGURATOR: "Reset configurator",
    SHAPE: "Shape",
    BLADE: "Blade",
    HANDLE: "Handle",
    BUTTON_MORE: "More",
    VIEW_LESS: "➖ See less",
    VIEW_MORE: "➕ View all blade shapes",
    ADD_TO_CART: "Add to cart",
    SOLD_OUT: "Sold out",
    SHARE: "Share Your Custom Knife",
    COPIED_TO_CLIPBOARD: "Copied to clipboard",
    BLADE_MODAL: {
      DESCRIPTION_TAB_NAME: "Description",
      SPECIFICATIONS_TAB_NAME: "Specifications",
      BLADE_SHAPE: "Blade shape",
      STEEL_TYPE: "Steel type",
      BLADE_CONSTRUCTION: "Blade construction",
      HARDNESS: "Hardness (HRC scale)",
      OVERALL_LENGTH: "Overall length",
      BLADE_LENGTH: "Blade length",
      BLADE_HEIGHT: "Blade height",
      SPINE_THICKNESS: "Spine thickness",
      WEIGHT: "Weight",
      HANDLE_LENGTH: "Handle length",
      HANDLE_TYPE_WOOD: "Handle type / wood",
      KANJI_ON_THE_BLADE: "Kanji on the blade",
      BLACKSMITH: "Blacksmith",
      LOCATION_OF_THE_SMITHY: "Location of the smithy",
    }
  }
  
  window.TRANSLATIONS = TRANSLATIONS;
})();